import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, CardBody, Col, Container, Input, Row, Tooltip} from "reactstrap";
import infoIcon from "../../assets/img/icons/user/info-icon.png";
import {useHistory, useLocation, useParams} from "react-router-dom";
import Swal from "sweetalert2";
import {collection, doc, getDoc, getDocs, increment, query, setDoc, updateDoc, where} from "firebase/firestore";
import {getDb} from "../../util/Constants";
import {fileUpload, sendInviteEmail} from "util/UploadUsers";

const Invitation = ({ signedInUser, userData }) => {
    const [email, setEmail] = useState("");
    const [loader, setLoader] = useState(null);
    const [uploadFiles, setUploadFiles] = useState(null);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [tooltipText, setTooltipText] = useState("Copy Link");
    const fileInputRef = useRef(null);
    const [usersCount, setUsersCount] = useState(0);
    const history = useHistory();
    const { eventId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const gameLink = queryParams.get('game_link');
    const db = getDb();
    const isProgress = signedInUser.projectType === "progress";

    useEffect(async () => {
        // console.log(userData, signedInUser);
        // console.log(eventId, "Evet id");
        // if (signedInUser?.usersCount) {
        //     setUsersCount(signedInUser?.usersCount);
        // }

        const docRef = doc(getDb(), "admins", signedInUser.uid);
        const docSnap = await getDoc(docRef);
        setUsersCount(docSnap.data().usersCount)
    }, [])

    const toggle = () => setTooltipOpen(!tooltipOpen);
    const handleCopy = () => {

        navigator.clipboard.writeText(gameLink);
        setTooltipText('Copied!');
        setTimeout(() => {
            toggle()
        }, 1000);
        setTimeout(() => {
            setTooltipText('Copy Link');
        }, 2000)
    };
    const visitDashboard = () => {
        history.push("/assessment/dashboard");
    }
    const onInviteClick = async () => {
        setLoader("invite");
        if (email) {
            const emailExistsQuery = query(
                collection(db, "users"),
                where("email_insensitive", "==", email.toLowerCase()), where('eventId', '==', eventId)
            );
            const emailExistsSnapshot = await getDocs(emailExistsQuery);

            if (!emailExistsSnapshot.empty) {
                setLoader(null);
                return Swal.fire({
                    icon: 'error',
                    title: 'Email already exists',
                    text: 'The provided email is already registered.',
                });
            }

            if (usersCount < signedInUser?.maxUsers) {
                const userId = signedInUser?.reloadUserInfo?.localId;
                // update the user count in the database using fieldValue.increment
                await setDoc(doc(db, "users", email + eventId), {
                    eventId: eventId,
                    achievementCount: 0,
                    achievements: {
                        highAchiever: 0,
                        mostlyRight: 0,
                        speedDemon: 0,
                        streakOf10: 0,
                    },
                    attempts: 1,
                    avatar: -1,
                    capabilities: {},
                    completed: false,
                    completedOnce: false,
                    currentLevel: 1,
                    currentScore: 0,
                    cognitiveScore: 0,
                    aptitudeScore: 0,
                    behaviourScore: 0,
                    department: "",
                    email: email,
                    email_insensitive: email.toLowerCase(),
                    isActive: true,
                    canExpire: false,
                    lastCompletedScore: 0,
                    lastUpdated: Date.now(),
                    levelScores: {},
                    levels: {},
                    name: email.split("@")[0],
                    name_insensitive: email.split("@")[0].toLowerCase(),
                    region: "",
                    userCreated: Date.now(),
                    expiryDate: "",
                    userInfo: {email: email, email_insensitive: email.toLowerCase()}
                });

                await updateDoc(doc(getDb(), "admins", userId), {
                    usersCount: increment(1),
                });
                await updateDoc(doc(db, "users", "analytics"), {
                    [eventId]: increment(1),
                });

                await sendInviteEmail(email, eventId); // sending invite email

                setUsersCount(usersCount + 1);
                setEmail("");
                setLoader(null);
                Swal.fire({
                    icon: 'success',
                    title: 'Invitation Sent!',
                    text: 'Invitation has been sent to the candidate.',
                });
            } else {
                setLoader(null);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'You have reached your maximum users limit. Please upgrade your plan to add more users.',
                });
            }
        } else {
            setLoader(null);
            return Swal.fire({
                icon: 'error',
                title: 'Please provide Email',
                text: 'Email field is required',
            });
        }
    };
    const getUsersEmail = async (data) => {
        let emails = []
        const emailsData = data.map((e, index) => e.email).filter((e) => e);

        const citiesRef = collection(db, 'users');

        // batch size of 10
        const batchSize = 10;
        for (let i = 0; i < emailsData.length; i += batchSize) {
            const batch = emailsData.slice(i, i + batchSize);
            const q = query(citiesRef, where('email', 'in', batch), where("eventId", "==", eventId));
            const querySnapshot = await getDocs(q);
            const documents = querySnapshot.docs;

            if (documents) {
                documents.forEach((doc) => {
                    const data = doc.data();
                    emails.push(data.email)
                });
            }
        }
        return emails
    }
    const handleFileUpload = async (event) => {
        const file = event.target.files[0];
        // setUploadFiles(file);
        console.log("1");
        setLoader("bulkUpload");
        
        try {
            const count = await fileUpload(file, signedInUser?.maxUsers, signedInUser.uid, usersCount, eventId, db, gameLink,signedInUser);
          console.log(count);
          setUsersCount(count);
          fileInputRef.current.value = null; // Reset file input value
          console.log("2"); // Move the second console.log here, after the asynchronous operations
        } catch (error) {
          // Handle any errors that occurred during the asynchronous operations
        }
        setLoader(null);
        console.log("3");

    };
    const downloadSample = () => {
        const csvContent = `email,\nexample1@example.com\nexample2@example.com\nexample3@example.com\nexample4@example.com`;
      
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
      
        const link = document.createElement('a');
        link.href = url;
        link.download = 'sample.csv';
        link.click();
      
        URL.revokeObjectURL(url);
    }

      
    return (
        <div>
            <Container className="mt-5">
                <div className="d-flex justify-content-center">
                    <Card className="step1-card br-15">
                        <CardBody className="startCard pt-3">
                            <h1 className="font-weight-bold text-center">Invite Your Candidates!</h1>
                            <h4 className="font-weight-bold text-center">{usersCount}/{signedInUser?.maxUsers}</h4>
                            <Row>
                                <Col sm={12} lg={6} xs={12}>
                                    <div className="mt-5">
                                        <label className="fs-14 ml-2 font-weight-bolder text-muted">Single Email
                                            Invite</label>
                                        <div className="d-flex">
                                            <Input type='email' placeholder="Type Email Address Here"
                                                   className="assessment-input" value={email}
                                                   onChange={(e) => setEmail(e.target.value)}/>
                                            <div className="py-2">
                                                <Button className="inviteButton" type="submit"
                                                        disabled={loader === "invite"}
                                                        onClick={(e) => onInviteClick()}
                                                        color="">
                                                    {loader === "invite" ?
                                                        <>
                                                        <span className="spinner-border spinner-border-sm" role="status"
                                                              aria-hidden="true">
                                                        </span>
                                                            <span className="sr-only">Loading...</span>
                                                        </> : "Invite"}</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <label className="fs-14 ml-2 font-weight-bolder text-muted">Bulk Invite</label>
                                        <p className="details ml-2">Invite multiple candidates using bulk upload.
                                            Download Sample CSV from <span className="text-blue text-underline"
                                                                           role="button"
                                                                           onClick={downloadSample}>here</span></p>
                                        <span>
                                                <label htmlFor="imageUpload" role="button"
                                                       className={"nextButton px-sm-0 border-0 text-white px-5 w-100 text-center"}>
                                                    {/* <i className="fa fa-upload mr-2" /> */}
                                                    {loader === "bulkUpload" ? "Loading..." : <span>Bulk Invite</span>}
                                                </label>
                                                <input ref={fileInputRef} disabled={loader === "bulkUpload"}
                                                       onChange={handleFileUpload} className="d-none" id="imageUpload"
                                                       type="file"/>
                                            </span>
                                    </div>
                                    {/*<Row className="mt-5">*/}
                                    {/*    <Col lg={6} sm={12} xs={12}>*/}
                                    {/*        <Button className="previous-button text-white w-100" type="submit"*/}
                                    {/*            disabled={loader === "invite"}*/}
                                    {/*            onClick={(e) => onInviteClick()}*/}
                                    {/*            color="">*/}
                                    {/*            {loader === "invite" ?*/}
                                    {/*                <>*/}
                                    {/*                    <span className="spinner-border spinner-border-sm" role="status"*/}
                                    {/*                        aria-hidden="true">*/}
                                    {/*                    </span>*/}
                                    {/*                    <span className="sr-only">Loading...</span>*/}
                                    {/*                </> : "Invite"}*/}
                                    {/*        </Button>*/}
                                    {/*    </Col>*/}
                                    {/*    <Col lg={6} sm={12}>*/}
                                    {/*        /!* <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"*/}
                                    {/*            color="">Bulk Invite</Button> *!/*/}
                                    {/*        <span>*/}
                                    {/*            <label htmlFor="imageUpload" role="button"*/}

                                    {/*                className={"nextButton px-sm-0 border-0 text-white px-5 w-100 text-center"}>*/}
                                    {/*                /!* <i className="fa fa-upload mr-2" /> *!/*/}
                                    {/*                {loader === "bulkUpload" ? "Loading..." : <span>Bulk Invite</span>}*/}
                                    {/*            </label>*/}
                                    {/*            <input ref={fileInputRef} disabled={loader === "bulkUpload"}*/}
                                    {/*                onChange={handleFileUpload} className="d-none" id="imageUpload"*/}
                                    {/*                type="file" />*/}
                                    {/*        </span>*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                </Col>
                                <Col sm={12} lg={6} xs={12}>
                                    <div className="mt-5">
                                        <label className="fs-14 ml-2 font-weight-bolder text-muted">Game URL has been
                                            activated</label>
                                        <div
                                            className="d-flex assessment-input align-items-center justify-content-between">
                                            <span className="text-nowrap overflow-hidden">{gameLink}</span>
                                            <Button className="nextButton text-white" id="copy"
                                                    onClick={handleCopy}>Copy</Button>
                                            <Tooltip
                                                placement="bottom"
                                                isOpen={tooltipOpen}
                                                target="copy"
                                                toggle={toggle}
                                                className="custom-tooltip"
                                            >
                                                {tooltipText}
                                            </Tooltip>
                                        </div>
                                    </div>
                                    <Button className="previous-button text-white w-100 mt-5"
                                        color="" onClick={visitDashboard}>Visit Dashboard</Button>
                                    <div className="d-flex mt-3">
                                        <div>
                                            <img src={infoIcon} role="button" />
                                        </div>
                                        <div className="ml-1">
                                            <p className="details mt-1">Visit Dashboard to view Reports for
                                                this {isProgress ? 'game' : 'assessment'}.</p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default Invitation;
